var BimeManager = {};

/**@param {object} inputsObject */
BimeManager.makeBody = function(url="",inputsObject={})
{
    var urlVarBody = "" ;
    for (var key in inputsObject) {
        if (urlVarBody !== "") {
            urlVarBody += "&";
        }
        urlVarBody += key + "=" + encodeURIComponent(inputsObject[key]);
    }
    return {
        url:url,
        body:urlVarBody
    }
}



/**@param {object} inputsObject */
BimeManager.makeGetBody = function(inputsObject={})
{
    var urlVarBody = "" ;
    for (var key in inputsObject) {
       
        if(inputsObject[key]!=null && typeof(inputsObject[key])==='object' && inputsObject[key].length !== undefined)
        {
            for(var i = 0 ; i<inputsObject[key].length ; i++)
            {
                if (urlVarBody !== "") {
                    urlVarBody += "&";
                }
                urlVarBody += key + "=" + encodeURIComponent(inputsObject[key][i]);
            }
        }
        else
        {
            if (urlVarBody !== "") {
                urlVarBody += "&";
            }
            urlVarBody += key + "=" + encodeURIComponent(inputsObject[key]);
        }
    }
    return urlVarBody ;
}


/*alert(
    BimeManager.makeGetBody({a:1,b:2,c:[4,5,6]})
);*/


BimeManager.encodeResult = function(resultObject={})
{
    return resultObject ;
}

/**http://185.184.32.33 */
BimeManager.reactRedirectDomain = "https://mteaminterfaceapi.novininsurance.com/api/PostResponse" ;
/**http://appsrv.novininsurance.com/ */

BimeManager.reactRedirectDomain1 = "https://mteaminterfaceapi.novininsurance.com/api/PostResponse1" ;

BimeManager.etelaatshoab = "https://mteamshoabapi.novininsurance.com/api/LocationApi";


BimeManager.header = function()
{
    return {headers:{Authorization:"Basic bm8xMnZpbkJOOjg4ODgyODE4OA==",HeaderToken:"7be2r6h1-d1a8-40fe-905c-2e8p651ebccc"}}
}

export default BimeManager ;


// WEBPACK FOOTER //
// ./src/Core/BimeManager.js